import { FC, useMemo, useState } from "react";
import { useInventoryContext } from "../../../hooks/use-inventory";
import { CollectionsEnum } from "../../../lib/enums";
import { InventoryItem } from "../../../lib/types";
import {
  Dialog,
  DialogFooter,
  DialogHeader,
  DialogContent,
  DialogDescription,
  DialogTitle,
  DialogClose,
  DialogTrigger,
  Select,
  SelectTrigger,
  SelectContent,
  SelectValue,
  SelectGroup,
  SelectItem,
  SelectLabel,
  Button,
} from "../../../components/ui";
import { toast } from "sonner"

type MoveInventoryDialogProps = {
  isShowing: boolean,
  selectedItems: InventoryItem[],
  close: () => void
}

export const MoveInventoryDialog: FC<MoveInventoryDialogProps> = ({
  isShowing,
  selectedItems,
  close
}) => {

  const { bins, binLocationMap, deleteInventoryElem, addInventoryElem, updateInventoryElem, unitNameMap } = useInventoryContext()

  const [selectedUnit, setSelectedUnit] = useState("")
  const [selectedLocation, setSelectedLocation] = useState("")

  const binSelectOptions = useMemo(() => {
    setSelectedLocation("")

    return bins
      .filter((i) => i.unit === selectedUnit)
      .map((k) => {
        return <SelectItem value={k.id} key={k.id}>{binLocationMap[k.id]}</SelectItem>
      })
  }, [selectedUnit])

  return (
    <Dialog
      open={isShowing}
      onOpenChange={close}
    >
      <DialogTrigger />
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Move Inventory Item(s)</DialogTitle>
        </DialogHeader>
        <DialogDescription className="flex flex-col">
          <div className="font-bold">Move to</div>

          <div className="flex flex-col gap-2">
            <Select
              defaultValue={selectedUnit}
              onValueChange={(value: string) => {
                setSelectedUnit(value)
              }}
            >
              <SelectTrigger>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectGroup>
                  <SelectLabel>Unit</SelectLabel>
                  {
                    Object.keys(unitNameMap).map((k) => {
                      return <SelectItem value={k} key={k}>{unitNameMap[k]}</SelectItem>
                    })
                  }
                </SelectGroup>
              </SelectContent>
            </Select>

            {selectedUnit && <>
              <Select
                defaultValue={selectedLocation}
                onValueChange={(value: string) => { setSelectedLocation(value) }}
              >
                <SelectTrigger>
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectGroup>
                    <SelectLabel>Bin</SelectLabel>
                    {binSelectOptions.map((i) => { return i })}
                  </SelectGroup>
                </SelectContent>
              </Select>
            </>}
          </div>
        </DialogDescription>
        <DialogFooter className="flex gap-1">
          <DialogClose className="w-full">
            <Button
              variant={"outline"}
              className="w-full rounded"
            >
              close
            </Button>
          </DialogClose>
          <Button
            onClick={async () => {
              //Update all inventory items in that bin
              selectedItems.forEach((i) => {
                i.unit = selectedUnit
                i.location = selectedLocation
                updateInventoryElem(i, CollectionsEnum.INVENTORY_ITEM)
              })

              toast.info("item(s) location updated")
              setSelectedUnit("")
              setSelectedLocation("")

              close()
            }}
            className="w-full"
            disabled={selectedLocation === "" || selectedUnit === ""}
          >
            {"move "} item(s)
          </Button>

        </DialogFooter>
      </DialogContent>
    </Dialog>

  )
}
